import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';

import { GuidedWorkflowsCategoriesComponent } from './components/guided-workflows-categories.component';
import { GuidedWorkflowsMenuComponent } from './components/guided-workflows-menu.component';
import { GuidedWorkflowsStepsComponent } from './components/guided-workflows-steps.component';

@NgModule({
    imports: [CommonModule, FormsModule, IconModule, TooltipModule],
    declarations: [GuidedWorkflowsMenuComponent, GuidedWorkflowsCategoriesComponent, GuidedWorkflowsStepsComponent],
    exports: [GuidedWorkflowsMenuComponent],
})
export class GuidedWorkflowsMenuModule {}
